import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  useMediaQuery,
  Drawer,
  Grid,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailSignupModal from "./EmailSignupModal";
import sharifLogo from "../images/sharifLogo.jpg";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "transparent!important",
    color: "#000",
    boxShadow: "none",
    position: "absolute!important",
    width: "100%",
  },
  menuButton: {
    color: "white!important",
    background: "transparent!important",
    fontFamily: "'Montserrat'",
    fontSize: "1rem",
    lineHeight: "1.25",
    padding: "0 .25rem",
    borderRadius: "0!important",
    textTransform: "uppercase!important",
  },
  link: {
    textDecoration: "none",
    color: "#106cb7",
    fontFamily: "'Montserrat'",
    fontSize: "1rem",
    lineHeight: "1.25",
    padding: "0 .25rem",
  },
  toolbar: {
    justifyContent: "space-between",
  },
  drawerList: {
    width: 250,
  },
  menuIcon: {
    color: "white",
  },
}));

const Navbar = () => {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState(false);
const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [emailOpen, setEmailOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const location = useLocation();

  const drawerList = () => (
    <div
      className={classes.drawerList}
      onClick={(e) => {
        if (e.target.tagName !== "A") toggleDrawer(false);
      }}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        <ListItemButton component={Link} to="/" onClick={toggleDrawer(false)}>
          <ListItemText primary="HOME" />
        </ListItemButton>
        <ListItemButton
          component={Link}
          to="/meetsharif"
          onClick={toggleDrawer(false)}
        >
          <ListItemText primary="ABOUT SHARIF" />
        </ListItemButton>

        <ListItemButton
          component={Link}
          to="/priorities"
          onClick={toggleDrawer(false)}
        >
          <ListItemText primary="ISSUES" />
        </ListItemButton>
        {/* <ListItemButton
          component={Link}
          to="/media"
          onClick={toggleDrawer(false)}
        >
          <ListItemText primary="MEDIA" />
        </ListItemButton> */}
        {/* <ListItemButton
          component="a"
          href=""
          target="_blank"
          rel="noopener noreferrer"
        >
          <ListItemText primary="CONTACT" />
        </ListItemButton> */}
        <ListItemButton
          component="a"
          href="https://docs.google.com/forms/d/1kW751kMXg1Cvjeq4PpGNXS4BAddEvivJMuCWnpNhtmU/edit"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ListItemText primary="VOLUNTEER" />
        </ListItemButton>
        <ListItemButton
          component="a"
          href="https://voterservices.elections.maryland.gov/OnlineVoterRegistration/InstructionsStep1"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ListItemText primary="REGISTER TO VOTE" />
        </ListItemButton>
        {/* <ListItemButton
          component="a"
          onClick={() => setEmailOpen(true)}
        >
          <ListItemText primary="JOIN US" />
        </ListItemButton> */}

        {/* <ListItemButton
          component="a"
          href=""
          target="_blank"
          rel="noopener noreferrer"
        >
          <ListItemText primary="DONATE" />
        </ListItemButton> */}
      </List>
    </div>
  );

  return (
    <AppBar
      className={classes.appBar}
      sx={{ background: isMobile ?  "transparent" : "#FFFDF7!important", p: 1, pb: 0 }}
    >
      <Toolbar className={classes.toolbar} sx={{ px: "0!important" }}>
        <Box display={{ xs: "none", md: "flex", width: "100%" }}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="flex-start"
            sx={{
              py: 1,
              px: 1,
              width: "100%",
              borderRadius: ".5rem",
            }}
          >
            {/* Logo */}
            <Grid item>
              <Link to="/">
                <Box
                  component="img"
                  src={sharifLogo}
                  alt="Sharif Logo"
                  sx={{
                    borderRadius: ".5rem",
                    width: "200px",
                    height: "auto",
                  }}
                />
              </Link>
            </Grid>
            <Grid item>
              <Button className={classes.menuButton}>
                <Link to="/priorities" className={`${classes.link}`}>
                  Issues
                </Link>
              </Button>
              {/* <Button className={classes.menuButton}>
                <Link to="/" className={`${classes.link}`}>
                  Contact
                </Link>
              </Button> */}
              {/* <Button
                component="a"
                href="https://forms.gle/5pwrC3iqZqjzfoKu6"
                target="_blank"
                rel="noopener noreferrer"
                variant="text"
                color="inherit"
              
                sx={{
                  color: "#106cb7!important",
                  padding: "0 .25rem",
                  fontSize: "1rem",
                  fontFamily: "'Montserrat'",
                  lineHeight: "1.25",
                  textDecoration: "none",
                }}
              >
                Contact
              </Button> */}
              {/* <Button
                className={classes.menuButton}
                onClick={() => setEmailOpen(true)}
              >
                <span className={classes.link}>join our team</span>
              </Button> */}
              {/* <Button className={classes.menuButton}>
                <Link to="/media" className={`${classes.link}`}>
                  Media
                </Link>
              </Button> */}
              {/* <Button
                className={classes.menuButton}
          
              >
                <span className={classes.link}>store</span>
              </Button> */}
              <Button
                className={`${classes.link}`}
                sx={{
                  color: "white!important",
                  margin: "0 .25rem!important",
                  padding: "0.25rem .5rem!important",
                  background: "transparent!important",
                  borderRadius: "0!important",
                  textTransform: "uppercase!important",
                  fontSize: "1rem",
                  fontFamily: "'Montserrat'",
                  lineHeight: "1.25",
                  textDecoration: "none",
                }}
              >
                <Link to="/meetsharif" className={`${classes.link}`}>
                  ABOUT SHARIF
                </Link>
              </Button>
              <Button
                className={`${classes.link}`}
                sx={{
                  color: "white!important",
                  margin: "0 .25rem!important",
                  padding: "0.25rem .5rem!important",
                  background: "transparent!important",
                  borderRadius: "0!important",
                  textTransform: "uppercase!important",
                  fontSize: "1rem",
                  fontFamily: "'Montserrat'",
                  lineHeight: "1.25",
                  textDecoration: "none",
                }}
              >
                <Link to="https://voterservices.elections.maryland.gov/OnlineVoterRegistration/InstructionsStep1" className={`${classes.link}`} target="_blank">
                  REGISTER TO VOTE
                </Link>
              </Button>
              <IconButton
                component="a"
                href="https://instagram.com/SharifHidayat320"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ ml: 1 }}
              >
                <InstagramIcon
                  sx={{
                    color:
                      location.pathname === "/"
                        ? "#106cb7!important"
                        : "#106cb7!important",
                  }}
                />
              </IconButton>
              <IconButton
                component="a"
                href="https://x.com/votesharif2026"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ ml: 1 }}
              >
                <XIcon sx={{ color: "#106cb7!important" }} />
              </IconButton>
              <IconButton
                component="a"
                href="https://facebook.com/VoteSharifDistrict7"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon
                  sx={{
                    color:
                      location.pathname === "/"
                        ? "#106cb7!important"
                        : "#106cb7!important",
                  }}
                />
              </IconButton>
              <Button
                className={classes.menuButton}
                sx={{
                  background: "#106cb7!important",
                  p: "0.75rem 2rem!important",
                  borderRadius: ".25rem!important",
                  ml: "1rem!important",
                  color: "white!important",
                }}
              >
                <a
                  href="https://docs.google.com/forms/d/1kW751kMXg1Cvjeq4PpGNXS4BAddEvivJMuCWnpNhtmU/edit"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.menuButton}
                >
                  Volunteer
                </a>
              </Button>
              {/* <Button
                className={classes.menuButton}
                sx={{
                  background: "#FF0000!important",
                  p: "0.75rem 2rem!important",
                  borderRadius: ".25rem!important",
                  ml: ".5rem!important",
                }}
              >
                <a
                  href="/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.menuButton}
                  sx={{ color: "white!important" }}
                >
                  donate
                </a>
              </Button> */}
            </Grid>
          </Grid>
        </Box>

        <Box display={{ xs: "flex", md: "none", marginTop: "-28px" }}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(true)}
          >
            <MenuIcon sx={{ color: "white" }} />
          </IconButton>
        </Box>
      </Toolbar>
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        {drawerList()}
      </Drawer>
      <EmailSignupModal
        open={emailOpen}
        handleClose={() => setEmailOpen(false)}
      />
    </AppBar>
  );
};

export default Navbar;
